__turbopack_context__.v({
  "scoreLabel": "dKPp8q_scoreLabel",
  "wrapper": "dKPp8q_wrapper",
});
